import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiProfileService } from '../services/api-profile.service';
import { TokenStorageService } from '../services/token-storage.service';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {
  private readonly apiProfileService = inject(ApiProfileService);
  private readonly tokenStorage = inject(TokenStorageService);

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    const profile = this.apiProfileService.findProfileByRequestUrl(request.url);

    if (
      profile === null ||
      request.url === `${profile.baseUrl}${profile.signIn?.path ?? ''}`
    ) {
      return next.handle(request);
    }

    const credentials = this.tokenStorage.getCredentials(profile.id);
    let authenticatedRequest = request;

    if (
      profile.bearer !== undefined &&
      credentials.bearerToken !== undefined &&
      !authenticatedRequest.headers.has(profile.bearer.headerName)
    ) {
      authenticatedRequest = authenticatedRequest.clone({
        setHeaders: {
          [profile.bearer.headerName]:
            `${profile.bearer.prefix} ${credentials.bearerToken}`,
        },
      });
    }

    if (
      profile.apiKey !== undefined &&
      credentials.apiKey !== undefined &&
      !authenticatedRequest.headers.has(profile.apiKey.headerName)
    ) {
      authenticatedRequest = authenticatedRequest.clone({
        setHeaders: {
          [profile.apiKey.headerName]: credentials.apiKey,
        },
      });
    }

    return next.handle(authenticatedRequest);
  }
}
